// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
export const iconSetPath =
  'assets/icons/elm-app451-icon-set-e31d6df4a259d381.svg';
